/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './maintenance.user.tpl.html';

angular
  .module('shared.maintenanceMode', ['ui.router'])
  // This defines the maintenance mode view that is shared across all subviews.
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      $stateProvider.state(VIEW_STATES.MAINTENANCE_MODE, {
        url: '/maintenanceMode',
        views: {
          content: {
            templateUrl: 'shared/maintenanceMode/maintenance.user.tpl.html'
          }
        }
      });
    }
  ]);
